import type { GoogleAnalyticsKey } from './types';
import { createSubscriptionMap } from '../core/subscription';

/**
 * GTM 套餐价格映射表
 */
export const GTAG_MAP = createSubscriptionMap<GoogleAnalyticsKey>(({ value, name }) => ({
  value,
  analysis: name,
}));

export const DEFAULT_GTM_CONTAINER_ID = 'GTM-MVLT2RQV';
